import { GridColDef } from "@mui/x-data-grid-pro";
import { IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../components/global/DynamicIcon";
import LargeItemStatus from "../../../../../../common/components/large_item_status";

type Props = {
  onActionEditar: (id: number | null, openState: boolean) => void;
};

export const GenerateManutencaoSolicitacaoColumnDefinition = ({
  onActionEditar,

}: Props): GridColDef[] => {
  const computeStatusDescription = (status: string) => {
    switch (status) {
      case "E":
        return "Em Aberto";
      case "A":
        return "Andamento";
      case "R":
        return "Reprovada";
      case "F":
        return "Finalizada";
      default:
        return "Desconhecido";
    }
  };

  const computeStatusColor = (status: string) => {
    switch (status) {
      case "E":
        return "green";
      case "A":
        return "yellow";
      case "R":
        return "red";
      case "F":
        return "blue";
      default:
        return "gray";
    }
  };

  return [
    {
      field: "status",
      headerName: "Status",
      maxWidth: 100,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <LargeItemStatus
            title={computeStatusDescription(params.value)}
            color={computeStatusColor(params.value)}
            description=""
          />
        </div>
      ),
    },
    {
      field: "nroManutencao",
      headerName: "Número",
      maxWidth: 80,
      sortable: false,
      filterable: false,
    },
    {
      field: "nomeCentroCusto",
      headerName: "Centro de Custo",
      flex: 1,
      minWidth: 150,
      width: 200,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex break-normal">
          <span>{params.value}</span>
        </div>
      ),
    },
    {
      field: "descricao",
      headerName: "Descrição do Problema",
      flex: 1,
      minWidth: 180,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex break-normal">
          <span>{params.value}</span>
        </div>
      ),
    },
    {
      field: "observacao",
      headerName: "Descrição da Manutenção",
      flex: 1,
      minWidth: 180,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex break-normal">
          <span>{params.value}</span>
        </div>
      ),
    },
    {
      field: "dataSolicitacao",
      headerName: "Data Solicitação",
      width: 100,
      sortable: false,
      filterable: false,
      valueGetter: (params) => (params ? new Date(params).toLocaleDateString("pt-BR", { timeZone: "UTC" }) : ""),
    },
    {
      field: "dataAprovacao",
      headerName: "Data Aprovação",
      width: 100,
      sortable: false,
      filterable: false,
      valueGetter: (params) => (params ? new Date(params).toLocaleDateString("pt-BR", { timeZone: "UTC" }) : ""),
    },
    {
      field: "dataPrevConclusao",
      headerName: "Previsão Conclusão",
      width: 100,
      sortable: false,
      filterable: false,
      valueGetter: (params) => (params ? new Date(params).toLocaleDateString("pt-BR", { timeZone: "UTC" }) : ""),
    },
    {
      field: "dataConclusao",
      headerName: "Data Conclusão",
      width: 100,
      sortable: false,
      filterable: false,
      valueGetter: (params) => (params ? new Date(params).toLocaleDateString("pt-BR", { timeZone: "UTC" }) : ""),
    },
    {
      field: "nomeFuncionarioAprovacao",
      headerName: "Aprovado/Reprovado por",
      width: 150,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex break-normal">
          <span>{params.value}</span>
        </div>
      ),
    },
    {
      field: "nomeFornecedorResponsavel",
      headerName: "Responsável pela Manutenção",
      width: 150,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex break-normal">
          <span>{params.value}</span>
        </div>
      ),
    },
    {
      field: "idManutencao",
      headerName: "	Visualizar",
      width: 100,
      minWidth: 100,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <div className="flex items-center justify-center w-full h-full gap-2">
          <IconButton onClick={() => onActionEditar(params.row.idManutencao, true)}>
            <DynamicIcon nameIcon="Visibility" size={25} className="text-yellow-500" />
          </IconButton>
        </div>
      ),
    },
  ];
};
